export const deliverabilityPostmasterAppGroupIdDeliveryErrors =
  "/deliverability/postmaster/:app_group_id/delivery_errors";
